export const ATT_APP_INSTALL_URL = 'market://details?id=com.anotherclass.attendance';
